import React, { useState } from 'react'
import "./layout.css";
import PaysignLogo from '../assets/paysign-logo.svg'
import { Button, Drawer, message } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import ShieldIcon from '../assets/icons/shield.svg'
import { useNavigate } from 'react-router-dom';
import { LOGOUT_URL } from '../api/URLs';
import portalAPI from '../api/api';
import { useDispatch, useSelector } from 'react-redux';
import { userLogout } from '../stores/authenticated-user.store';
import { TbLogout2 } from 'react-icons/tb';

import UserIcon from '../assets/icons/users.svg';
import WalletIcon from '../assets/icons/wallet.svg';
import HeadphoneIcon from '../assets/icons/headphones.svg'

const LilyHeader = () => {
    const user = useSelector((state) => state.authenticatedUser);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleLogout = async () => {
        setLoading(true);
        try {
            await portalAPI.post(LOGOUT_URL);
            dispatch(userLogout());
            navigate('/auth/login');
        } catch (error) {
            message.error(error?.response?.data?.message || 'Failed to logout. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className='lily-header'>
                <div className='content'>
                    <img style={{ cursor: 'pointer' }} onClick={() => navigate('/dashboard')} className='logo' alt='Paysign Logo' src={PaysignLogo} />
                    <div className='d-flex flex-row align-items-center gap-5'>
                        <Button
                            className='p-0 cus-btn'
                            icon={<img alt='logo' style={{ width: '27px' }} src={HeadphoneIcon} />}
                            color="default"
                            variant="link"
                            onClick={() => {
                                navigate('/contact-us');
                                setIsMenuOpen(false);
                            }}
                        >
                            Support
                        </Button>
                        <Button
                            size='large'
                            color="default"
                            variant="text"
                            icon={<MenuOutlined />}
                            onClick={() => setIsMenuOpen(true)}
                        />
                    </div>
                </div>
            </div>
            <Drawer
                title=""
                closable={{ 'aria-label': 'Close Button' }}
                onClose={() => setIsMenuOpen(false)}
                open={isMenuOpen}
            >
                <div className="h-100 d-flex flex-column justify-content-between align-items-start">
                    {
                        user ? (
                            <>
                                <div className='d-flex flex-column align-items-start gap-3'>
                                    <Button
                                        className='p-0 cus-btn'
                                        icon={<img alt='logo' src={UserIcon} />}
                                        color="default"
                                        variant="link"
                                        onClick={() => {
                                            navigate('/user-details');
                                            setIsMenuOpen(false);
                                        }}
                                    >
                                        User Details
                                    </Button>
                                    <Button
                                        className='p-0 cus-btn'
                                        icon={<img alt='logo' src={WalletIcon} />}
                                        color="default"
                                        variant="link"
                                        onClick={() => {
                                            navigate('/setting/reimbursement-methods');
                                            setIsMenuOpen(false);
                                        }}
                                    >
                                        Reimbursement Methods
                                    </Button>
                                    <Button
                                        className='p-0 cus-btn'
                                        icon={<img alt='logo' src={ShieldIcon} />}
                                        color="default"
                                        variant="link"
                                        onClick={() => {
                                            navigate('/term-of-use');
                                            setIsMenuOpen(false);
                                        }}
                                    >
                                        Terms + Conditions
                                    </Button>
                                </div>
                                <Button
                                    className='p-0 cus-btn'
                                    icon={<TbLogout2 style={{ fontSize: '28px', color: 'var(--primary-color)' }} />}
                                    color="default"
                                    variant="link"
                                    loading={loading}
                                    onClick={handleLogout}
                                >
                                    Log out
                                </Button>
                            </>
                        ) : (
                            <div className='d-flex flex-column align-items-start gap-3'>
                                <Button
                                    className='p-0'
                                    icon={<img alt='logo' src={ShieldIcon} />}
                                    color="default"
                                    variant="link"
                                    onClick={() => {
                                        navigate('/term-of-use');
                                        setIsMenuOpen(false);
                                    }}
                                >
                                    Terms + Conditions
                                </Button>
                            </div>
                        )
                    }
                </div>
            </Drawer>
        </>
    )
}

export default LilyHeader